import { GetOrganizationStatus } from './types';

export const getOrganizationStatus: GetOrganizationStatus = ({ active }) => {
    if (!active) {
        return 'disabled';
    }
    return 'active';
};
